import React, {useEffect, useState} from 'react';
import AdministrationView from './AdministrationView';
import {adminInfo} from '../.././services/MadricService';

/**
 * Permet de gérer tout ce qui à trait a l'administration
 * @return {JSX}
 */
function Administration() {
  const [finishLoading, setFinishLoading] = useState(false);
  const [factures, setFactures] = useState([]);
  const [taches, setTaches] = useState([]);
  const [employes, setEmployes] = useState([]);

  useEffect(() => {
    fetchAdminInfo();
  }, []);

  /**
   * Permet d'allez chercher la liste de factures, tâches et d'employés
   */
  async function fetchAdminInfo() {
    const res = await adminInfo();
    setFactures(res[0]);
    setTaches(res[1]);
    setEmployes(res[2]);
    setFinishLoading(true);
  }

  return (
    <div>
      {finishLoading ? <AdministrationView factures={factures} taches={taches} employes={employes} setEmployes={setEmployes} setTaches={setTaches} setFactures={setFactures}/> : ''}
    </div>
  );
}

export default Administration;
